// `useNetworkConfig()` — client hook that returns the full network
// config (apiUrl, rpcUrl, programId) for the user's ACTIVE network —
// the gate-clamped `useActiveNetwork()`, so a stored `mainnet`
// preference binds devnet while `mainnet_enabled` is off. Reactive:
// re-runs when the user toggles networks or the gate flips.
//
// Use this anywhere a client component needs a per-network value that
// used to come from `env.NEXT_PUBLIC_API_URL` / `_RPC_URL` / etc.

'use client';

import { getNetworkConfig, type NetworkConfig } from './config';
import { useActiveNetwork } from './use-active-network';

export function useNetworkConfig(): NetworkConfig {
  return getNetworkConfig(useActiveNetwork());
}
